import React, { PropsWithChildren } from "react";
import S from './MainHero.styled';

type Props = {
  button: {
    target: string;
    title: string;
    url: string;
  };
  title: string;
  background?: string;
  sticky?: boolean;
  onClick?: Function;
  expandCard?: boolean;
  className?: string;
  mixed?: boolean;
};

const StickyButton: React.FC<PropsWithChildren<Props>> = (props) => {
  return (
    <S.StyledDefaultButtonDark mixed={props.mixed} className={props.className} expandCard={props.expandCard} onClick={(e) => props.onClick && props.onClick(e)} sticky={props.sticky} id={props.title} background={props.background} >
      <div>{props.title}</div>
      {props.children}
    </S.StyledDefaultButtonDark>
  );
};

export default StickyButton;
